import React, { useEffect, useRef, useState } from "react";

const GridDialogBox = ({
  tablefields,
  selectedHeaders,
  handleClose,
  onHeadersChange,
}) => {
  const dialogRef = useRef(null);
  const [selected, setSelected] = useState(selectedHeaders);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dialogRef.current && !dialogRef.current.contains(event.target)) {
        handleClose(); // Close the dialog if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClose]);

  const handleCheckboxChange = (fieldValue) => {
    let updatedHeaders;
    if (selected.includes(fieldValue)) {
      updatedHeaders = selected.filter((header) => header !== fieldValue);
    } else {
      updatedHeaders = [...selected, fieldValue];
    }
    setSelected(updatedHeaders);
    onHeadersChange(updatedHeaders); // Update parent component
  };

  return (
    <div
      ref={dialogRef}
      className="absolute right-10 top-20 sm:top-70 mt-2 w-[70vw] sm:w-96 bg-white border rounded-md shadow-lg p-4 z-30"
    >
      <div className="space-y-2">
        {tablefields.map((field) => (
          <div key={field.value} className="flex items-center space-x-2">
            <input
              type="checkbox"
              checked={selected.includes(field.value)}
              onChange={() => handleCheckboxChange(field.value)}
              className="custom-checkbox"
            />
            <span>{field.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GridDialogBox;
